import React, {Component} from 'react';




export default class Footer extends Component{


    render(){
        return(
            <div className="h-[200px] bg-indigo-800 w-[100vw] text-[1.5vw] text-white font-bold rounded-t-3xl">
                <h1 className="text-center relative pt-[2vw]">Developed by Nirmal Chaudhari Aug 2023</h1>

            </div>
        )
    }
}




